/**
 * PROTOTYPE CONTENT — NOT VERIFIED. Restored verbatim from `design-reference/`.
 * These vacancies do not exist. Advertising a role that is not open — with a
 * closing date on it — wastes applicants' time and is the fastest way to lose a
 * reputation with the people the company will need to hire. Remove or replace
 * before publication. See CONTENT-STATUS.md.
 */
export interface Job {
  id: string
  title: string
  loc: string
  type: string
  dept: string
  exp: string
  /** Closing date. */
  close: string
  desc: string
  reqs: string[]
}

export const jobs: Job[] = [
  {
    id: 'j1',
    title: 'Site Agent — Earthworks',
    loc: 'Centurion, Gauteng',
    type: 'Permanent',
    dept: 'Civils',
    exp: '6+ years',
    close: '30 Sep 2026',
    desc: 'Run the Erf 1140 bulk earthworks contract day to day: programme, survey control, plant utilisation and the site safety file.',
    reqs: [
      'NDip/BTech Civil Engineering',
      '6 years on bulk earthworks contracts',
      'Survey and setting-out competence',
      'Valid Code B licence',
    ],
  },
  {
    id: 'j2',
    title: 'Quantity Surveyor',
    loc: 'Burgersfort, Limpopo',
    type: 'Permanent',
    dept: 'Commercial',
    exp: '4+ years',
    close: '22 Sep 2026',
    desc: 'Measurement, monthly valuations, variations and subcontract accounts across all six live contracts. You will be the second commercial appointment in the company.',
    reqs: [
      'BSc QS or NDip Building',
      'CCS Candy proficiency essential',
      'JBCC and GCC 2015 exposure',
      'Comfortable in a small, fast-moving team',
    ],
  },
  {
    id: 'j3',
    title: 'SHEQ Officer',
    loc: 'Emalahleni, Mpumalanga',
    type: 'Fixed term — 12 months',
    dept: 'SHEQ',
    exp: '3+ years',
    close: '18 Sep 2026',
    desc: 'Site-level safety, health and environmental compliance on a live mine access road contract with active haulage alongside the works.',
    reqs: [
      'SAMTRAC certified',
      'Mine site experience essential',
      'Incident investigation (ICAM)',
      'Red Ticket advantageous',
    ],
  },
]
